import { render, staticRenderFns } from "./CouponsData.vue?vue&type=template&id=3ac2b65a&scoped=true&"
import script from "./CouponsData.vue?vue&type=script&lang=js&"
export * from "./CouponsData.vue?vue&type=script&lang=js&"
import style0 from "./CouponsData.vue?vue&type=style&index=0&id=3ac2b65a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ac2b65a",
  null
  
)

export default component.exports